import store from '@/store';
import router from '@/router';

export default {
  canActivate() {
    return new Promise((resolve, reject) => (store.state.auth.token ? resolve() : router.replace({ name: 'Welcome' }) && reject()));
  },
};



// WEBPACK FOOTER //
// ./src/guards/auth.js